import { render, staticRenderFns } from "./StockProductPicker.vue?vue&type=template&id=6723a203"
import script from "./StockProductPicker.vue?vue&type=script&lang=js"
export * from "./StockProductPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports